export default __webpack_public_path__ + "static/media/cheff.87144195.jpg";